import { inject, Injectable } from '@angular/core';
import { DataLayerPayload } from '@libs/shop/models';
import { TrackingGoogleService } from '@libs/shared/tracking';

/**
 * Pushes SRM related tracking events to the GTM data layer.
 */
@Injectable({ providedIn: 'root' })
export class SrmTrackingService {
  private readonly tracking: TrackingGoogleService = inject(TrackingGoogleService);

  public trackSrmRequest(payload: DataLayerPayload<'srmRequest'>): void {
    this.tracking.trackEvent('srmRequest', this.normalizeSrmPayload(payload) as DataLayerPayload<'srmRequest'>);
  }

  public trackSrmDetail(payload: DataLayerPayload<'srmDetail'>): void {
    this.tracking.trackEvent('srmDetail', this.normalizeSrmPayload(payload) as DataLayerPayload<'srmDetail'>);
  }

  /**
   * Normalizes SRM tracking labels by trimming whitespace and replacing internal whitespace with dashes.
   */
  public normalizeSrmPayload(payload: DataLayerPayload<'srmRequest' | 'srmDetail'>): DataLayerPayload<'srmRequest' | 'srmDetail'> {
    const normalize = (value: string | null): string | null => (value ? value.trim().replace(/\s+/g, '-') : null);

    return {
      ...payload,
      srmCategory: normalize(payload.srmCategory),
      srmIssue: normalize(payload.srmIssue),
      srmTopic: normalize(payload.srmTopic),
    };
  }

}
